import React from 'react';
import Form from '../forms/Form';
import Input from '../forms/Input';
import { QuestRoute } from '../api/QuestRoutes';
import { irregularPluralization } from '../utility/functions';
import HamQuest from '../api/HamQuestGiver';
import Modal from '../Modal';
import Preput from '../forms/Preput';
import ModalFactory from '../Modal';


const TargetedNotification = ({ users, ...props }) => {
    return (
        <Form
            inputs={{
                title: '',
                body: '',
            }}
            onSubmit={e => HamQuest.post(QuestRoute.notifications.new, {
                ...e,
                userIds: users.map(e => e.userId)
            })
                .then(() => ModalFactory.show({
                    title: 'Sent',
                    body: 'Notification send successfully.'
                }))}
            text='Send'
        >
            {({ values }) => (
                <>
                    <span>Send a targeted push notification to {users.length} {irregularPluralization(users.length, 'person', 'people')}.</span>
                    <Input
                        label='Notification Title'
                        name='title'
                        required
                    />
                    <Preput
                        label='Notification Body'
                        name='body'
                        required
                    />
                </>
            )}
        </Form>
    )
}

export default TargetedNotification;
